export const getRouteTitle = (pathname: string, customTitles?: Record<string, string>): string => {
	const defaultTitles: Record<string, string> = {
		'/': 'Home',
		'/dashboard': 'Dashboard',
		'/flora-ai': 'Flora AI',
		'/propriedades': 'Propriedades',
		'/recomendacoes': 'Recomendações',
		'/produtos': 'Produtos',
		'/solicitacoes': 'Solicitações',
		'/suporte': 'Suporte',
		'/meu-plano': 'Meu Plano',
		'/perfil': 'Perfil & Preferências',
		'/operacional': 'Operacional',
		'/usuarios': 'Usuários',
		'/parcelamento': 'Parcelamento',
		'/politicas': 'Políticas',
		'/parametros': 'Parâmetros',
		'/configuracoes': 'Configurações',
		'/configuracoes/gateways': 'Gateways de Pagamento',
		'/sistema': 'Sistema',
		'/sistema/novo': 'Sistema',
		'/sistema/ver': 'Sistema',
	};

	const titles = { ...defaultTitles, ...customTitles };

	if (titles[pathname]) {
		return titles[pathname];
	}

	const firstSegment = pathname.split('/').find(Boolean);
	if (firstSegment) {
		const basePath = '/' + firstSegment;
		if (titles[basePath]) {
			return titles[basePath];
		}
		return firstSegment.charAt(0).toUpperCase() + firstSegment.slice(1).replace(/-/g, ' ');
	}

	return 'Home';
};
